import { FormInput } from "./form-components/form-input.components";
import { FormRange } from "./form-components/form-range.components";
import type { Path, UseFormReturn } from "react-hook-form";
import type { IzCampaignFormAdmin } from "../z/admin/campaign-form.admin.z";
import millify from "millify";

type BudgetCardProps = {
	form: UseFormReturn<IzCampaignFormAdmin>; // Use the specific form type
	name: Path<IzCampaignFormAdmin>;
	name2: Path<IzCampaignFormAdmin>;
	label: string;
	label2: string;
	required?: boolean;
	maxBudget: number;
	setMaxBudget: (value: number) => void;
};

const BudgetCard = ({
	form,
	label,
	name,
	required = false,
	maxBudget,
	setMaxBudget,
	name2,
	label2,
}: BudgetCardProps) => {
	return (
		<div className="flex justify-between items-center p-8 border border-[--border] rounded-xl w-full">
			<div className="flex flex-col gap-20 w-full">
				<div className="flex justify-between items-center">
					<FormInput
						form={form}
						name={name2}
						label={label2}
						placeholder="Enter client budget"
						required={required}
						type="number"
						onChange={(value) => {
							form.setValue(name2, Number.parseInt(value));
							//   if (Number.parseInt(value) > maxBudget) {
							setMaxBudget(Number.parseInt(value));
							//   }
						}}
					/>
					<hr className="opacity-30 w-1/5 rotate-90" />
					<FormInput
						form={form}
						name={name}
						label={label}
						placeholder="Enter budget here"
						required={required}
						type="number"
						onChange={(value) => {
							form.setValue(name, Number.parseInt(value));
						}}
					/>
				</div>

				<div className="flex flex-col gap-2 w-full">
					<FormRange
						form={form}
						name={name}
						max={
							Number(form.getValues(name2))
								? Number(form.getValues(name2))
								: maxBudget
						}
						onValueChange={(value) => form.setValue(name, value)}
					/>
					<div className="flex justify-between items-center w-full font-semibold text-[18px]">
						<span>₹0</span>
						<span>
							₹
							{form.getValues(name2) !== null &&
							form.getValues(name2) !== undefined
								? millify(Number(form.getValues(name2)) || 0)
								: millify(maxBudget)}
						</span>
					</div>
				</div>
			</div>
		</div>
	);
};

export default BudgetCard;
